import { SET_FAVOURITES } from './../const';

export default (favourites) => {
    return {
      type: SET_FAVOURITES,
      favourites
    }
};
